export default __webpack_public_path__ + "static/media/radio-content.d7555e6e.svg";